import { Injectable } from "@angular/core";
import { AccountService } from "@gtmhub/accounts/accounts-service";
import { hasCurrentUserRole } from "@gtmhub/users";
import { PermissionsFacade } from "@webapp/permissions/services/permissions-facade.service";
import { Observable, of, zip, map, from } from "rxjs";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { FeatureToggleService } from "@gtmhub/featureToggle";

@Injectable()
export class AccountOptionsVisibilityService {
  constructor(private permissionsFacade: PermissionsFacade, private accountService: AccountService, private featureToggleService: FeatureToggleService) {}

  get anyOption$(): Observable<boolean> {
    return zip(this.accountAndDomain$, this.auditLog$, this.branding$, this.billing$, this.singleSignOn$).pipe(
      map(([accountAndDomain, auditLog, branding, billing, singleSignOn]) => {
        return accountAndDomain || auditLog || branding || billing || singleSignOn;
      })
    );
  }

  get accountAndDomain$(): Observable<boolean> {
    return of(hasCurrentUserRole("admin"));
  }

  get branding$(): Observable<boolean> {
    return this.permissionsFacade.hasPermission$("ManageConfiguration");
  }

  get auditLog$(): Observable<boolean> {
    return zip(from(this.featureToggleService.isFeatureAvailable(FeatureFlag.AuditLog)), of(hasCurrentUserRole("admin"))).pipe(
      map(([featureAvailable, isAdmin]) => {
        return featureAvailable && isAdmin;
      })
    );
  }

  get billing$(): Observable<boolean> {
    return this.permissionsFacade.hasPermission$("ManageBilling");
  }

  get singleSignOn$(): Observable<boolean> {
    return zip(this.permissionsFacade.hasPermission$("ManageConfiguration"), of(this.accountService.featureAvailable("authentication.activedirectory"))).pipe(
      map(([isFeatureAvailable, accessPeople]) => {
        return isFeatureAvailable && accessPeople;
      })
    );
  }
}
